<div
  [innerHTML]="text | atxRemoveMarkdown | markdown | async | safeHtml: true"
></div>
